// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2qXMU","resendInfoText":"OnGoingPaymentBox_resendInfoText__roCkI"};